import { useMemo } from "react";
import riderDebugApkUrl from "../../android/mozzo-kiosk/we-rider-app/build/outputs/apk/debug/we-rider-app-debug.apk";
import riderReleaseApkUrl from "../../android/mozzo-kiosk/we-rider-app/build/outputs/apk/release/we-rider-app-release.apk";
import { getRuntimeEnvironment } from "../../services/local/runtimeEnvironment";

const APK_FILE_NAMES = Object.freeze({
  beta: "We-Rider-Beta.apk",
  production: "We-Rider.apk",
});

export default function WeRiderAndroidLauncher({ compact = false }) {
  const launcher = useMemo(() => {
    const userAgent = typeof navigator === "undefined" ? "" : navigator.userAgent;
    if (/MozzoWeRider\/[\d.]+/i.test(userAgent)) return null;

    const isProduction = getRuntimeEnvironment() === "production";
    const selectedUrl = isProduction ? riderReleaseApkUrl : riderDebugApkUrl;
    return {
      url:
        selectedUrl && typeof window !== "undefined"
          ? new URL(selectedUrl, window.location.origin).toString()
          : selectedUrl,
      fileName: isProduction ? APK_FILE_NAMES.production : APK_FILE_NAMES.beta,
    };
  }, []);

  if (!launcher?.url) return null;

  return (
    <a
      className={`we-rider-android-download${compact ? " is-compact" : ""}`}
      href={launcher.url}
      download={launcher.fileName}
      title="Descargar launcher Android de We! Rider"
    >
      <span aria-hidden="true">↓</span>
      <strong>{compact ? "Android" : "Descargar app Android"}</strong>
    </a>
  );
}
